import {UICoreCookies} from "@flashpointbv/solar-ui-core";

window.addEventListener('load', () => {
  document.querySelectorAll('.main__footer-container h3').forEach(el => {
    el.addEventListener('click', e => {
      const clickEl = (e.target as HTMLElement);
      const navEl = clickEl.nextElementSibling as HTMLElement;

      let showBlock = navEl.style.display === 'block' ? 'none' : 'block';
      document.querySelectorAll('.main__footer-container ul').forEach(el => {
        (el as HTMLElement).style.display = 'none';
      });
      document.querySelectorAll('.main__footer-container h3').forEach(el => {
        (el as HTMLElement).classList.remove('_active');
      });

      if (showBlock === 'block') {
        clickEl.classList.add('_active');
      } else {
        clickEl.classList.remove('_active');
      }
      navEl.style.display = showBlock;
    });
  });

  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !(window as any).MSStream;
  if (isIOS) {
    document.querySelectorAll('nav ul li a').forEach(el => {
      el.addEventListener('click', e => {
        if ((el.nextElementSibling as HTMLElement).style.display === 'block') {
          window.location.href = el.getAttribute('href');
        }
      });
    });
  }
});

if(document.getElementsByClassName('home__categories').length > 0) {
  document.addEventListener('DOMContentLoaded', function () {
    ('.home__categories li > a').matchHeight();
  });
}

('nav>ul').dropDown(el => {
  const dropDown = el.getElementsByClassName('_dropdown');
  el.classList.add('_active');
  if (dropDown.length > 0) {
    const overlayDiv = document.getElementsByClassName('nav__overlay')[0] as HTMLElement;
    dropDown[0].style.display = 'block';
    overlayDiv.classList.add('active');
  }
}, el => {
  const dropDown = el.getElementsByClassName('_dropdown');
  el.classList.remove('_active');
  if (dropDown.length > 0) {
    const overlayDiv = document.getElementsByClassName('nav__overlay')[0] as HTMLElement;
    dropDown[0].style.display = 'none';
    overlayDiv.classList.remove('active');
  }
});

const getCookieMessage = new UICoreCookies().getCookie('cookie-message');
